<script setup lang="ts">
import { mdiEye, mdiEyeOff } from '@mdi/js';
import VeeTextField from '@/components/forms/TextField/VeeTextField.vue';
import type { VeePasswordFieldProps } from '../types';

const show = defineModel('show', { type: Boolean, default: false });

// default is needed: absent boolean props would otherwise be passed on to VeeTextField as `false`
const props = withDefaults(defineProps<VeePasswordFieldProps>(), { validateOnBlur: true });
</script>

<template>
  <VeeTextField
    v-bind="props"
    :type="show ? 'text' : 'password'"
    :appendInnerIcon="show ? mdiEyeOff : mdiEye"
    @click:appendInner="show = !show"
  />
</template>
